<template>
  <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="supplier"
    :saveMethod="saveMethod" :readonly="readonly">
    <template v-slot:content="{ item, editMode, handleFocus }">
      <v-container fluid>
        <v-row>
          <v-col cols=" 12">
            <QTextField v-model="item.SupplierNumber" :label="$t('servicesystem.common_objects.supplier.number')"
              maxlength="50" :externaledit="editMode" :disabled="readonly" @FocusState="handleFocus">
            </QTextField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <QTextField v-model="item.Name" :label="$t('servicesystem.common_objects.supplier.name')" maxlength="50"
              :rules="[requiredRule]" :externaledit="editMode" :disabled="readonly" @FocusState="handleFocus">
            </QTextField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <QCheckboxInput v-model="item.IsActive" :label="$t('servicesystem.common_objects.commonterms.active')"
              :externaledit="editMode" :disabled="readonly" @FocusState="handleFocus">
            </QCheckboxInput>
          </v-col>
        </v-row>
        <!-- 
        <v-row>
          <v-col cols="12">
            <QTextField :value="i18nFormatDateTime(item.Modified)"
              :label="$t('servicesystem.common_objects.commonterms.modified')" disabled>
            </QTextField>
          </v-col>
        </v-row>
        -->
      </v-container>
    </template>
  </EntityEditCard>
</template>


<script>
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";

export default {
  name: "SupplierDetails",
  props: {
    supplier: Object,
    saveMethod: Function,
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EntityEditCard,
  },
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>